import { render, staticRenderFns } from "./AddColumnForm.vue?vue&type=template&id=1792ff00"
import script from "./AddColumnForm.vue?vue&type=script&lang=js"
export * from "./AddColumnForm.vue?vue&type=script&lang=js"
import style0 from "./AddColumnForm.vue?vue&type=style&index=0&id=1792ff00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports